import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/billing')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/billing' });
  },
});
